import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// datav组件库
// import dataV from '@jiaminghi/data-view'
// Vue.use(dataV)

// element ui组件库
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//echarts图标库
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.prototype.imgUrl = '@/assets/img/'

import request from "@/common/request"
Vue.prototype.$request = request;
// 跳转url
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

import changePicker from "@/components/change-picker/src/picker/date-picker.js";
Vue.component('changePicker',changePicker)
import Department from "@/components/department";
Vue.component('Department',Department)
import changeCascader from "@/components/change-cascader/cascader"
Vue.component('changeCascader',changeCascader)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
